module.exports = __webpack_public_path__ + "static/img/120_TO8_1657_og.a449b79.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/120_TO8_1657_og.jpg
// module id = 66m0
// module chunks = 0